import React, { Fragment } from 'react';
import PainPostCard from './PainPostCard';
import PainResultsCard from './PainResultsCard';


function ResultsList({
  posts,
  extractToJson,
  handleClearResults,
  handleExtractPains,
  extractingPains,
  extractedPains,
  openPainExpanderPermalink,
}) {
  return (
    <div className="results-screen" data-testid="painExtractor-resultsScreen">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-[#022B3A] dark:text-[#FFFFFF]">Found {posts.length} {posts.length === 1 ? 'potential post' : 'potential posts'}</h2>
        <div className="flex items-center gap-4">
          <button id="save-results-button" onClick={extractToJson} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="painExtractor-saveToJsonButton">
            <span className="material-symbols-outlined text-base">download</span>
            Save to JSON
          </button>
          <button id="clear-results-button" onClick={handleClearResults} className="bg-[var(--color-primary-accent)] text-white font-medium py-2 px-4 rounded-lg flex items-center gap-2 hover:bg-[var(--color-primary-accent-hover)] transition-colors" data-testid="painExtractor-clearResultsButton">
            <span className="material-symbols-outlined text-base">delete</span>
            Clear Results
          </button>
        </div>
      </div>

      <div className="space-y-6">
        {posts.map((post) => (
          <Fragment key={post.permalink}>
            <PainPostCard
              post={post}
              handleExtractPains={handleExtractPains}
              extractingPains={extractingPains}
              openPainExpanderPermalink={openPainExpanderPermalink}
            />
            {openPainExpanderPermalink === post.permalink && (
              <PainResultsCard pains={extractedPains[post.permalink]} />
            )}
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default ResultsList;
